import { coreApi } from '@cp/shared/api/core';

export const coreAdminApiBalanceApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getApiBalance: builder.query<Record<string, number | null>, void>({
      query: () => ({
        method: 'GET',
        url: 'admin/balance',
      }),
    }),
  }),

  overrideExisting: false,
});
